// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__2rl3D","title":"styles_title__3dTpH","text":"styles_text__3ZThc"};